import { useRef } from 'react';
import { useGlobeSection } from '../stage/Stage';
import { useLocale, ROUTES } from '../i18n/locale';
import { sectionId } from '../content/site';
import { HOME } from './content';
import { Lines } from './Lines';

/** The globe leads; the promise is short and the next step is always visible. */
export function Hero() {
  const { locale } = useLocale(); const copy = HOME[locale].hero;
  const ref = useRef<HTMLElement>(null);
  useGlobeSection(ref, 'hero', (_metrics, stage) => stage.globe.hero());
  return (
    <section ref={ref} id="inicio" className="hero" data-tone="dark" aria-labelledby="hero-title">
      <div className="hero__inner wrap">
        <div className="hero__copy">
          <p className="hero__eyebrow">{copy.eyebrow}</p>
          <h1 id="hero-title" className="hero__title"><Lines lines={copy.title} /></h1>
          <p className="hero__lead"><Lines lines={copy.lead} /></p>
          <div className="hero__actions">
            <a className="cta cta--primary" href={ROUTES.intake[locale]}>{copy.primary}</a>
            <a className="cta cta--quiet" href={`#${sectionId('operate', locale)}`}>{copy.secondary}</a>
          </div>
        </div>
        <p className="hero__caption"><span className="hero__node" aria-hidden="true" />{copy.caption}</p>
      </div>
    </section>
  );
}
